import { Branch, Tenant, User } from "@/types/models";
import { usePage } from "@inertiajs/react";

export const useUser = () => usePage().props.user as User | undefined;

export const useTenant = () => {
  const { tenant, user } = usePage().props as { tenant?: Tenant; user?: User };

  return tenant ?? user?.tenant;
};

export const useCurrentBranch = () => {
  const { branchContext } = usePage().props as { branchContext?: { currentBranch?: Branch } | null };

  return branchContext?.currentBranch;
};
